import { Conversation } from "~/components/conversation";

export function ParcelChat({ parcelId }: { parcelId: string }) {
  return (
    <div className="border-hairline bg-card rounded-xl border p-5">
      <h2 className="type-headline mb-3">Messages</h2>
      <Conversation
        parcelId={parcelId}
        viewer="customer"
        emptyText="A question about this parcel? Write to our team here."
        label="Message to ParcelPoint"
        placeholder="Write a message"
      />
    </div>
  );
}
